(ns dashboard.config)

(def debug?
  ^boolean goog.DEBUG)

(goog-define environment "")
(goog-define version "")
(goog-define api-url "")
(goog-define auth0-domain "auth.tachikoma-ai.com")
(goog-define auth0-client-id "XLuxv3caHn0n1V8iETigOYfls9Hzde2y")
(goog-define auth0-audience "https://graphql.event-organizer.dev/graphql")

(goog-define sentry-dsn "https://f8003db5accf4661913b29452fb58a18@o4503922988810240.ingest.sentry.io/4505038530084864")
(goog-define graphql-host "graphql.event-organizer.dev")
(goog-define graphql-http-url "https://graphql.event-organizer.dev/graphql")
(goog-define graphql-ws-url "wss://graphql.event-organizer.dev/graphql/realtime")
(goog-define google-calendar-api-key "AIzaSyCc8HCpNMlAkEOJ9xHrXtPw-8uGRWB2LPU")
